import React, { useState } from 'react';
import { useAuth } from '../App';
import { api } from '../utils/api';
import { useFirmSettings } from '../contexts/FirmSettingsContext';

export default function AccountSettingsPage() {
  const { client } = useAuth();
  const { firm } = useFirmSettings();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword,     setNewPassword]     = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving,  setSaving]  = useState(false);
  const [status,  setStatus]  = useState('');
  const [error,   setError]   = useState('');

  async function handleChangePassword(e) {
    e.preventDefault();
    if (newPassword !== confirmPassword) return setError('New passwords do not match.');
    if (newPassword.length < 8) return setError('Password must be at least 8 characters.');
    setSaving(true); setStatus(''); setError('');
    try {
      await api.changePassword(currentPassword, newPassword);
      setStatus('Password changed successfully.');
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
    } catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  return (
    <div>
      <h1 className="page-title">Account Settings</h1>
      <p className="page-subtitle">Manage your portal account.</p>

      <div className="section-head">Account Information</div>
      <div className="card">
        <div className="summary-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, fontFamily: 'Arial, sans-serif', fontSize: 14 }}>
          <div>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Name</div>
            <div style={{ fontWeight: 500 }}>{client?.name}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Username</div>
            <div style={{ fontWeight: 500 }}>{client?.username}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Email</div>
            <div style={{ fontWeight: 500 }}>{client?.email || '—'}</div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Phone</div>
            <div style={{ fontWeight: 500 }}>{client?.phone || '—'}</div>
          </div>
        </div>
        <p style={{ fontSize: 12, color: '#888', fontFamily: 'Arial, sans-serif', marginTop: 16, marginBottom: 0 }}>
          To update your name, email, or phone number, please contact{firm.firm_name ? ' ' + firm.firm_name : ' the firm'}{firm.phone ? ' at ' + firm.phone : ''}.
        </p>
      </div>

      <div className="section-head">Change Password</div>
      <div className="card">
        {status && <div className="alert alert-success">{status}</div>}
        {error  && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleChangePassword}>
          <div className="form-group">
            <label>Current Password</label>
            <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
                placeholder="At least 8 characters" required />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? <><span className="spinner" />Saving...</> : 'Change Password'}
          </button>
        </form>
      </div>

      <div className="section-head">Firm Contact</div>
      <div className="card">
        <div style={{ fontSize: 14, fontFamily: 'Arial, sans-serif', lineHeight: 1.8 }}>
          {firm.firm_name && <><strong>{firm.firm_name}</strong><br /></>}
          {firm.business_street && <>{firm.business_street}<br /></>}
          {(firm.business_city || firm.business_state || firm.business_zip) && (
            <>{[firm.business_city,
                [firm.business_state, firm.business_zip].filter(Boolean).join(' ')]
              .filter(Boolean).join(', ')}<br /></>
          )}
          {firm.phone && <>{firm.phone}<br /></>}
          {firm.client_contact_email}
        </div>
      </div>
    </div>
  );
}
